import { render, staticRenderFns } from "./PoolSelection.vue?vue&type=template&id=c6707978&scoped=true"
import script from "./PoolSelection.vue?vue&type=script&lang=ts"
export * from "./PoolSelection.vue?vue&type=script&lang=ts"
import style0 from "./PoolSelection.vue?vue&type=style&index=0&id=c6707978&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6707978",
  null
  
)

export default component.exports